/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyairmintemperaturesetpoint4Inputs */



/**
* | output |
* | --- |
* | "Supply air minimum temperature" |
*
* @param {Ahu_History_Key_Supplyairmintemperaturesetpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyairmintemperaturesetpoint4 = /** @type {((inputs?: Ahu_History_Key_Supplyairmintemperaturesetpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyairmintemperaturesetpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air minimum temperature")
	return /** @type {LocalizedString} */ ("Température minimum air soufflé")
});
export { ahu_history_key_supplyairmintemperaturesetpoint4 as "ahu_history_key_supplyAirMinTemperatureSetpoint" }